import { useEffect } from 'react';
import type { TsoAuctionSettings } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useAuctionSettings(tsoId: number | string) {
  const request = useAxios(
    (axios, baseConfig, tsoId: number | string) =>
      axios.request<TsoAuctionSettings>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/tso/${tsoId}/auction-settings`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!tsoId) return request.setResponse(null);
    request.execute(tsoId);
    // oxlint-disable-next-line exhaustive-deps
  }, [tsoId]);

  return request;
}

export type AuctionSettingsRequest = ReturnType<typeof useAuctionSettings>;
